import React__default from 'react';
import { Manager, Reference } from 'react-popper';
import { TooltipContainer } from './components/TooltipContainer.js';
import { TooltipContent } from './components/TooltipContent.js';
import { TooltipMessage } from './components/TooltipMessage.js';
import { TooltipTrigger } from './components/TooltipTrigger.js';

const Tooltip = ({ id , message , className , placement , boundariesElement , label , renderLabel , 'aria-label': ariaLabel , iconName ='info' , theme , preventClickDefault , onClick , renderInPortal  })=>{
    return /*#__PURE__*/ React__default.createElement(TooltipContainer, {
        className: className,
        theme: theme
    }, /*#__PURE__*/ React__default.createElement(Manager, null, /*#__PURE__*/ React__default.createElement(Reference, null, ({ ref  })=>/*#__PURE__*/ React__default.createElement(TooltipTrigger, {
            id: id,
            "aria-label": ariaLabel,
            ref: ref,
            iconName: iconName,
            renderLabel: renderLabel,
            label: label,
            theme: theme,
            preventClickDefault: preventClickDefault,
            onClick: onClick
        })
    ), /*#__PURE__*/ React__default.createElement(TooltipContent, {
        id: id,
        placement: placement,
        boundariesElement: boundariesElement,
        theme: theme,
        renderInPortal: renderInPortal
    }, /*#__PURE__*/ React__default.createElement(TooltipMessage, {
        message: message
    }))));
};
var Tooltip$1 = Tooltip;

export { Tooltip$1 as default };
//# sourceMappingURL=Tooltip.js.map
